var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3a11"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3a11"] = parcelRequire;
}
var $1f3655405faf4b93$exports = {};
var $1f3655405faf4b93$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$1f3655405faf4b93$exports = // eslint-disable-next-line es/no-global-this -- safe
$1f3655405faf4b93$var$check(typeof globalThis == "object" && globalThis) || $1f3655405faf4b93$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$1f3655405faf4b93$var$check(typeof self == "object" && self) || $1f3655405faf4b93$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $1f3655405faf4b93$exports || Function("return this")();


var $1b14517606367da3$exports = {};
var $1eae0a73b36f2464$exports = {};
$1eae0a73b36f2464$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$1b14517606367da3$exports = !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $c4afc0259ed968b5$exports = {};
var $93b6f46cc432668a$exports = {};
var $e5e00809db8eb123$exports = {};
var $c3c0a5f76e5e916e$exports = {};

$c3c0a5f76e5e916e$exports = !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $e5e00809db8eb123$var$FunctionPrototype = Function.prototype;
var $e5e00809db8eb123$var$call = $e5e00809db8eb123$var$FunctionPrototype.call;
var $e5e00809db8eb123$var$uncurryThisWithBind = $c3c0a5f76e5e916e$exports && $e5e00809db8eb123$var$FunctionPrototype.bind.bind($e5e00809db8eb123$var$call, $e5e00809db8eb123$var$call);
$e5e00809db8eb123$exports = $c3c0a5f76e5e916e$exports ? $e5e00809db8eb123$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $e5e00809db8eb123$var$call.apply(fn, arguments);
    };
};



var $9261b09349da61cf$exports = {};
var $944ab8dbcfc949c5$exports = {};
var $944ab8dbcfc949c5$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $944ab8dbcfc949c5$var$IS_HTMLDDA = typeof $944ab8dbcfc949c5$var$documentAll == "undefined" && $944ab8dbcfc949c5$var$documentAll !== undefined;
$944ab8dbcfc949c5$exports = {
    all: $944ab8dbcfc949c5$var$documentAll,
    IS_HTMLDDA: $944ab8dbcfc949c5$var$IS_HTMLDDA
};


var $9261b09349da61cf$var$documentAll = $944ab8dbcfc949c5$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$9261b09349da61cf$exports = $944ab8dbcfc949c5$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $9261b09349da61cf$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $7d2461ccc847d891$exports = {};

var $563602a94d4dc012$exports = {};
var $fb9649058d88e05e$exports = {};
var $c9cec627d9a032db$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c9cec627d9a032db$exports = function(it) {
    return it === null || it === undefined;
};


var $fb9649058d88e05e$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$fb9649058d88e05e$exports = function(it) {
    if ($c9cec627d9a032db$exports(it)) throw $fb9649058d88e05e$var$$TypeError("Can't call method on " + it);
    return it;
};


var $563602a94d4dc012$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$563602a94d4dc012$exports = function(argument) {
    return $563602a94d4dc012$var$$Object($fb9649058d88e05e$exports(argument));
};


var $7d2461ccc847d891$var$hasOwnProperty = $e5e00809db8eb123$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$7d2461ccc847d891$exports = Object.hasOwn || function hasOwn(it, key) {
    return $7d2461ccc847d891$var$hasOwnProperty($563602a94d4dc012$exports(it), key);
};



var $93fac42f9e89a850$exports = {};


var $93fac42f9e89a850$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $93fac42f9e89a850$var$getDescriptor = $1b14517606367da3$exports && Object.getOwnPropertyDescriptor;
var $93fac42f9e89a850$var$EXISTS = $7d2461ccc847d891$exports($93fac42f9e89a850$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $93fac42f9e89a850$var$PROPER = $93fac42f9e89a850$var$EXISTS && (function something() {}).name === "something";
var $93fac42f9e89a850$var$CONFIGURABLE = $93fac42f9e89a850$var$EXISTS && (!$1b14517606367da3$exports || $1b14517606367da3$exports && $93fac42f9e89a850$var$getDescriptor($93fac42f9e89a850$var$FunctionPrototype, "name").configurable);
$93fac42f9e89a850$exports = {
    EXISTS: $93fac42f9e89a850$var$EXISTS,
    PROPER: $93fac42f9e89a850$var$PROPER,
    CONFIGURABLE: $93fac42f9e89a850$var$CONFIGURABLE
};


var $93b6f46cc432668a$require$CONFIGURABLE_FUNCTION_NAME = $93fac42f9e89a850$exports.CONFIGURABLE;
var $83eb0f09c907b53d$exports = {};


var $e44b1d7dc99fa8dc$exports = {};

var $43431a1908021c5f$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $43431a1908021c5f$var$defineProperty = Object.defineProperty;
$43431a1908021c5f$exports = function(key, value) {
    try {
        $43431a1908021c5f$var$defineProperty($1f3655405faf4b93$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $1f3655405faf4b93$exports[key] = value;
    }
    return value;
};


var $e44b1d7dc99fa8dc$var$SHARED = "__core-js_shared__";
var $e44b1d7dc99fa8dc$var$store = $1f3655405faf4b93$exports[$e44b1d7dc99fa8dc$var$SHARED] || $43431a1908021c5f$exports($e44b1d7dc99fa8dc$var$SHARED, {});
$e44b1d7dc99fa8dc$exports = $e44b1d7dc99fa8dc$var$store;


var $83eb0f09c907b53d$var$functionToString = $e5e00809db8eb123$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$9261b09349da61cf$exports($e44b1d7dc99fa8dc$exports.inspectSource)) $e44b1d7dc99fa8dc$exports.inspectSource = function(it) {
    return $83eb0f09c907b53d$var$functionToString(it);
};
$83eb0f09c907b53d$exports = $e44b1d7dc99fa8dc$exports.inspectSource;


var $b8c75d97df4614cd$exports = {};
var $b29a2b5771651d66$exports = {};


var $b29a2b5771651d66$var$WeakMap = $1f3655405faf4b93$exports.WeakMap;
$b29a2b5771651d66$exports = $9261b09349da61cf$exports($b29a2b5771651d66$var$WeakMap) && /native code/.test(String($b29a2b5771651d66$var$WeakMap));



var $2b8a0370e236b736$exports = {};


var $2b8a0370e236b736$var$documentAll = $944ab8dbcfc949c5$exports.all;
$2b8a0370e236b736$exports = $944ab8dbcfc949c5$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $9261b09349da61cf$exports(it) || it === $2b8a0370e236b736$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $9261b09349da61cf$exports(it);
};


var $11de2b231b2859ac$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $9ed44e563230b16a$export$2d1720544b23b823;

var $c6249751f0bc488c$exports = {};


var $af583e15a6d46412$exports = {};


var $af583e15a6d46412$var$document = $1f3655405faf4b93$exports.document;
// typeof document.createElement is 'object' in old IE
var $af583e15a6d46412$var$EXISTS = $2b8a0370e236b736$exports($af583e15a6d46412$var$document) && $2b8a0370e236b736$exports($af583e15a6d46412$var$document.createElement);
$af583e15a6d46412$exports = function(it) {
    return $af583e15a6d46412$var$EXISTS ? $af583e15a6d46412$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$c6249751f0bc488c$exports = !$1b14517606367da3$exports && !$1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($af583e15a6d46412$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


var $1981a0d5783b0827$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$1981a0d5783b0827$exports = $1b14517606367da3$exports && $1eae0a73b36f2464$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $3843f2a291eb95b4$exports = {};

var $3843f2a291eb95b4$var$$String = String;
var $3843f2a291eb95b4$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3843f2a291eb95b4$exports = function(argument) {
    if ($2b8a0370e236b736$exports(argument)) return argument;
    throw $3843f2a291eb95b4$var$$TypeError($3843f2a291eb95b4$var$$String(argument) + " is not an object");
};


var $eddfdd2f934c39a2$exports = {};
var $9224436324702004$exports = {};
var $52ac2d1f7b3fc221$exports = {};

var $52ac2d1f7b3fc221$var$call = Function.prototype.call;
$52ac2d1f7b3fc221$exports = $c3c0a5f76e5e916e$exports ? $52ac2d1f7b3fc221$var$call.bind($52ac2d1f7b3fc221$var$call) : function() {
    return $52ac2d1f7b3fc221$var$call.apply($52ac2d1f7b3fc221$var$call, arguments);
};



var $325cc76d61657af3$exports = {};
var $6bf58ff2790e62e4$exports = {};


var $6bf58ff2790e62e4$var$aFunction = function(argument) {
    return $9261b09349da61cf$exports(argument) ? argument : undefined;
};
$6bf58ff2790e62e4$exports = function(namespace, method) {
    return arguments.length < 2 ? $6bf58ff2790e62e4$var$aFunction($1f3655405faf4b93$exports[namespace]) : $1f3655405faf4b93$exports[namespace] && $1f3655405faf4b93$exports[namespace][method];
};



var $599d3f84718534dc$exports = {};

$599d3f84718534dc$exports = $e5e00809db8eb123$exports({}.isPrototypeOf);


var $b44ec27087c1b405$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $6414afa0b3d0491a$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $e686f780cf055b91$exports = {};

var $e37ccc3a3c9edcb0$exports = {};
$e37ccc3a3c9edcb0$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $e686f780cf055b91$var$process = $1f3655405faf4b93$exports.process;
var $e686f780cf055b91$var$Deno = $1f3655405faf4b93$exports.Deno;
var $e686f780cf055b91$var$versions = $e686f780cf055b91$var$process && $e686f780cf055b91$var$process.versions || $e686f780cf055b91$var$Deno && $e686f780cf055b91$var$Deno.version;
var $e686f780cf055b91$var$v8 = $e686f780cf055b91$var$versions && $e686f780cf055b91$var$versions.v8;
var $e686f780cf055b91$var$match, $e686f780cf055b91$var$version;
if ($e686f780cf055b91$var$v8) {
    $e686f780cf055b91$var$match = $e686f780cf055b91$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e686f780cf055b91$var$version = $e686f780cf055b91$var$match[0] > 0 && $e686f780cf055b91$var$match[0] < 4 ? 1 : +($e686f780cf055b91$var$match[0] + $e686f780cf055b91$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e686f780cf055b91$var$version && $e37ccc3a3c9edcb0$exports) {
    $e686f780cf055b91$var$match = $e37ccc3a3c9edcb0$exports.match(/Edge\/(\d+)/);
    if (!$e686f780cf055b91$var$match || $e686f780cf055b91$var$match[1] >= 74) {
        $e686f780cf055b91$var$match = $e37ccc3a3c9edcb0$exports.match(/Chrome\/(\d+)/);
        if ($e686f780cf055b91$var$match) $e686f780cf055b91$var$version = +$e686f780cf055b91$var$match[1];
    }
}
$e686f780cf055b91$exports = $e686f780cf055b91$var$version;




var $6414afa0b3d0491a$var$$String = $1f3655405faf4b93$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$6414afa0b3d0491a$exports = !!Object.getOwnPropertySymbols && !$1eae0a73b36f2464$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$6414afa0b3d0491a$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e686f780cf055b91$exports && $e686f780cf055b91$exports < 41;
});


$b44ec27087c1b405$exports = $6414afa0b3d0491a$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $325cc76d61657af3$var$$Object = Object;
$325cc76d61657af3$exports = $b44ec27087c1b405$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $6bf58ff2790e62e4$exports("Symbol");
    return $9261b09349da61cf$exports($Symbol) && $599d3f84718534dc$exports($Symbol.prototype, $325cc76d61657af3$var$$Object(it));
};


var $7449e8f88cb85375$exports = {};
var $828965f5bec31db8$exports = {};

var $4684c592a1598de6$exports = {};
var $4684c592a1598de6$var$$String = String;
$4684c592a1598de6$exports = function(argument) {
    try {
        return $4684c592a1598de6$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $828965f5bec31db8$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$828965f5bec31db8$exports = function(argument) {
    if ($9261b09349da61cf$exports(argument)) return argument;
    throw $828965f5bec31db8$var$$TypeError($4684c592a1598de6$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$7449e8f88cb85375$exports = function(V, P) {
    var func = V[P];
    return $c9cec627d9a032db$exports(func) ? undefined : $828965f5bec31db8$exports(func);
};


var $8cb92c64da7bae7c$exports = {};



var $8cb92c64da7bae7c$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$8cb92c64da7bae7c$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $9261b09349da61cf$exports(fn = input.toString) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    if ($9261b09349da61cf$exports(fn = input.valueOf) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    if (pref !== "string" && $9261b09349da61cf$exports(fn = input.toString) && !$2b8a0370e236b736$exports(val = $52ac2d1f7b3fc221$exports(fn, input))) return val;
    throw $8cb92c64da7bae7c$var$$TypeError("Can't convert object to primitive value");
};


var $a7e68d87528d04a9$exports = {};

var $c761b911d1948532$exports = {};
var $5c612855d4d64a1d$exports = {};
$5c612855d4d64a1d$exports = false;



($c761b911d1948532$exports = function(key, value) {
    return $e44b1d7dc99fa8dc$exports[key] || ($e44b1d7dc99fa8dc$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.31.0",
    mode: $5c612855d4d64a1d$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});



var $09622dafccffa283$exports = {};

var $09622dafccffa283$var$id = 0;
var $09622dafccffa283$var$postfix = Math.random();
var $09622dafccffa283$var$toString = $e5e00809db8eb123$exports(1.0.toString);
$09622dafccffa283$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $09622dafccffa283$var$toString(++$09622dafccffa283$var$id + $09622dafccffa283$var$postfix, 36);
};




var $a7e68d87528d04a9$var$Symbol = $1f3655405faf4b93$exports.Symbol;
var $a7e68d87528d04a9$var$WellKnownSymbolsStore = $c761b911d1948532$exports("wks");
var $a7e68d87528d04a9$var$createWellKnownSymbol = $b44ec27087c1b405$exports ? $a7e68d87528d04a9$var$Symbol["for"] || $a7e68d87528d04a9$var$Symbol : $a7e68d87528d04a9$var$Symbol && $a7e68d87528d04a9$var$Symbol.withoutSetter || $09622dafccffa283$exports;
$a7e68d87528d04a9$exports = function(name) {
    if (!$7d2461ccc847d891$exports($a7e68d87528d04a9$var$WellKnownSymbolsStore, name)) $a7e68d87528d04a9$var$WellKnownSymbolsStore[name] = $6414afa0b3d0491a$exports && $7d2461ccc847d891$exports($a7e68d87528d04a9$var$Symbol, name) ? $a7e68d87528d04a9$var$Symbol[name] : $a7e68d87528d04a9$var$createWellKnownSymbol("Symbol." + name);
    return $a7e68d87528d04a9$var$WellKnownSymbolsStore[name];
};


var $9224436324702004$var$$TypeError = TypeError;
var $9224436324702004$var$TO_PRIMITIVE = $a7e68d87528d04a9$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$9224436324702004$exports = function(input, pref) {
    if (!$2b8a0370e236b736$exports(input) || $325cc76d61657af3$exports(input)) return input;
    var exoticToPrim = $7449e8f88cb85375$exports(input, $9224436324702004$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $52ac2d1f7b3fc221$exports(exoticToPrim, input, pref);
        if (!$2b8a0370e236b736$exports(result) || $325cc76d61657af3$exports(result)) return result;
        throw $9224436324702004$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $8cb92c64da7bae7c$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$eddfdd2f934c39a2$exports = function(argument) {
    var key = $9224436324702004$exports(argument, "string");
    return $325cc76d61657af3$exports(key) ? key : key + "";
};


var $9ed44e563230b16a$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $9ed44e563230b16a$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9ed44e563230b16a$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9ed44e563230b16a$var$ENUMERABLE = "enumerable";
var $9ed44e563230b16a$var$CONFIGURABLE = "configurable";
var $9ed44e563230b16a$var$WRITABLE = "writable";
$9ed44e563230b16a$export$2d1720544b23b823 = $1b14517606367da3$exports ? $1981a0d5783b0827$exports ? function defineProperty(O, P, Attributes) {
    $3843f2a291eb95b4$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    $3843f2a291eb95b4$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $9ed44e563230b16a$var$WRITABLE in Attributes && !Attributes[$9ed44e563230b16a$var$WRITABLE]) {
        var current = $9ed44e563230b16a$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$9ed44e563230b16a$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $9ed44e563230b16a$var$CONFIGURABLE in Attributes ? Attributes[$9ed44e563230b16a$var$CONFIGURABLE] : current[$9ed44e563230b16a$var$CONFIGURABLE],
                enumerable: $9ed44e563230b16a$var$ENUMERABLE in Attributes ? Attributes[$9ed44e563230b16a$var$ENUMERABLE] : current[$9ed44e563230b16a$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $9ed44e563230b16a$var$$defineProperty(O, P, Attributes);
} : $9ed44e563230b16a$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3843f2a291eb95b4$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    $3843f2a291eb95b4$exports(Attributes);
    if ($c6249751f0bc488c$exports) try {
        return $9ed44e563230b16a$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $9ed44e563230b16a$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $0606df0cd9938668$exports = {};
$0606df0cd9938668$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$11de2b231b2859ac$exports = $1b14517606367da3$exports ? function(object, key, value) {
    return $9ed44e563230b16a$export$2d1720544b23b823(object, key, $0606df0cd9938668$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $6f16eb1940d3afb7$exports = {};


var $6f16eb1940d3afb7$var$keys = $c761b911d1948532$exports("keys");
$6f16eb1940d3afb7$exports = function(key) {
    return $6f16eb1940d3afb7$var$keys[key] || ($6f16eb1940d3afb7$var$keys[key] = $09622dafccffa283$exports(key));
};


var $0796b0af43a3801a$exports = {};
$0796b0af43a3801a$exports = {};


var $b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $b8c75d97df4614cd$var$TypeError = $1f3655405faf4b93$exports.TypeError;
var $b8c75d97df4614cd$var$WeakMap = $1f3655405faf4b93$exports.WeakMap;
var $b8c75d97df4614cd$var$set, $b8c75d97df4614cd$var$get, $b8c75d97df4614cd$var$has;
var $b8c75d97df4614cd$var$enforce = function(it) {
    return $b8c75d97df4614cd$var$has(it) ? $b8c75d97df4614cd$var$get(it) : $b8c75d97df4614cd$var$set(it, {});
};
var $b8c75d97df4614cd$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$2b8a0370e236b736$exports(it) || (state = $b8c75d97df4614cd$var$get(it)).type !== TYPE) throw $b8c75d97df4614cd$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($b29a2b5771651d66$exports || $e44b1d7dc99fa8dc$exports.state) {
    var $b8c75d97df4614cd$var$store = $e44b1d7dc99fa8dc$exports.state || ($e44b1d7dc99fa8dc$exports.state = new $b8c75d97df4614cd$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $b8c75d97df4614cd$var$store.get = $b8c75d97df4614cd$var$store.get;
    $b8c75d97df4614cd$var$store.has = $b8c75d97df4614cd$var$store.has;
    $b8c75d97df4614cd$var$store.set = $b8c75d97df4614cd$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $b8c75d97df4614cd$var$set = function(it, metadata) {
        if ($b8c75d97df4614cd$var$store.has(it)) throw $b8c75d97df4614cd$var$TypeError($b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $b8c75d97df4614cd$var$store.set(it, metadata);
        return metadata;
    };
    $b8c75d97df4614cd$var$get = function(it) {
        return $b8c75d97df4614cd$var$store.get(it) || {};
    };
    $b8c75d97df4614cd$var$has = function(it) {
        return $b8c75d97df4614cd$var$store.has(it);
    };
} else {
    var $b8c75d97df4614cd$var$STATE = $6f16eb1940d3afb7$exports("state");
    $0796b0af43a3801a$exports[$b8c75d97df4614cd$var$STATE] = true;
    $b8c75d97df4614cd$var$set = function(it, metadata) {
        if ($7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE)) throw $b8c75d97df4614cd$var$TypeError($b8c75d97df4614cd$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $11de2b231b2859ac$exports(it, $b8c75d97df4614cd$var$STATE, metadata);
        return metadata;
    };
    $b8c75d97df4614cd$var$get = function(it) {
        return $7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE) ? it[$b8c75d97df4614cd$var$STATE] : {};
    };
    $b8c75d97df4614cd$var$has = function(it) {
        return $7d2461ccc847d891$exports(it, $b8c75d97df4614cd$var$STATE);
    };
}
$b8c75d97df4614cd$exports = {
    set: $b8c75d97df4614cd$var$set,
    get: $b8c75d97df4614cd$var$get,
    has: $b8c75d97df4614cd$var$has,
    enforce: $b8c75d97df4614cd$var$enforce,
    getterFor: $b8c75d97df4614cd$var$getterFor
};


var $93b6f46cc432668a$var$enforceInternalState = $b8c75d97df4614cd$exports.enforce;
var $93b6f46cc432668a$var$getInternalState = $b8c75d97df4614cd$exports.get;
var $93b6f46cc432668a$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $93b6f46cc432668a$var$defineProperty = Object.defineProperty;
var $93b6f46cc432668a$var$stringSlice = $e5e00809db8eb123$exports("".slice);
var $93b6f46cc432668a$var$replace = $e5e00809db8eb123$exports("".replace);
var $93b6f46cc432668a$var$join = $e5e00809db8eb123$exports([].join);
var $93b6f46cc432668a$var$CONFIGURABLE_LENGTH = $1b14517606367da3$exports && !$1eae0a73b36f2464$exports(function() {
    return $93b6f46cc432668a$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $93b6f46cc432668a$var$TEMPLATE = String(String).split("String");
var $93b6f46cc432668a$var$makeBuiltIn = $93b6f46cc432668a$exports = function(value, name, options) {
    if ($93b6f46cc432668a$var$stringSlice($93b6f46cc432668a$var$$String(name), 0, 7) === "Symbol(") name = "[" + $93b6f46cc432668a$var$replace($93b6f46cc432668a$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$7d2461ccc847d891$exports(value, "name") || $93b6f46cc432668a$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($1b14517606367da3$exports) $93b6f46cc432668a$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($93b6f46cc432668a$var$CONFIGURABLE_LENGTH && options && $7d2461ccc847d891$exports(options, "arity") && value.length !== options.arity) $93b6f46cc432668a$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $7d2461ccc847d891$exports(options, "constructor") && options.constructor) {
            if ($1b14517606367da3$exports) $93b6f46cc432668a$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $93b6f46cc432668a$var$enforceInternalState(value);
    if (!$7d2461ccc847d891$exports(state, "source")) state.source = $93b6f46cc432668a$var$join($93b6f46cc432668a$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $93b6f46cc432668a$var$makeBuiltIn(function toString() {
    return $9261b09349da61cf$exports(this) && $93b6f46cc432668a$var$getInternalState(this).source || $83eb0f09c907b53d$exports(this);
}, "toString");



$c4afc0259ed968b5$exports = function(target, name, descriptor) {
    if (descriptor.get) $93b6f46cc432668a$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $93b6f46cc432668a$exports(descriptor.set, name, {
        setter: true
    });
    return $9ed44e563230b16a$export$2d1720544b23b823(target, name, descriptor);
};


var $3a153e2acfc103dd$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$3a153e2acfc103dd$exports = function() {
    var that = $3843f2a291eb95b4$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $0168b808d13fbd1d$var$RegExp = $1f3655405faf4b93$exports.RegExp;
var $0168b808d13fbd1d$var$RegExpPrototype = $0168b808d13fbd1d$var$RegExp.prototype;
var $0168b808d13fbd1d$var$FORCED = $1b14517606367da3$exports && $1eae0a73b36f2464$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $0168b808d13fbd1d$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($0168b808d13fbd1d$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($0168b808d13fbd1d$var$FORCED) $c4afc0259ed968b5$exports($0168b808d13fbd1d$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $3a153e2acfc103dd$exports
});


// TODO: Remove this module from `core-js@4` since it's split to modules listed below
var $7058f76fc2e3a64a$exports = {};

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $8d274edd5ac8b4e3$export$2d1720544b23b823;


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $5b404d3e79dbd64d$export$2d1720544b23b823;
"use strict";
var $5b404d3e79dbd64d$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5b404d3e79dbd64d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5b404d3e79dbd64d$var$NASHORN_BUG = $5b404d3e79dbd64d$var$getOwnPropertyDescriptor && !$5b404d3e79dbd64d$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$5b404d3e79dbd64d$export$2d1720544b23b823 = $5b404d3e79dbd64d$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5b404d3e79dbd64d$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5b404d3e79dbd64d$var$$propertyIsEnumerable;



var $90d3b62c7d13c648$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $d8b1bffb46e6bac1$exports = {};


var $ad4a9d272ee83106$exports = {};

var $ad4a9d272ee83106$var$toString = $e5e00809db8eb123$exports({}.toString);
var $ad4a9d272ee83106$var$stringSlice = $e5e00809db8eb123$exports("".slice);
$ad4a9d272ee83106$exports = function(it) {
    return $ad4a9d272ee83106$var$stringSlice($ad4a9d272ee83106$var$toString(it), 8, -1);
};


var $d8b1bffb46e6bac1$var$$Object = Object;
var $d8b1bffb46e6bac1$var$split = $e5e00809db8eb123$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$d8b1bffb46e6bac1$exports = $1eae0a73b36f2464$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$d8b1bffb46e6bac1$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $ad4a9d272ee83106$exports(it) == "String" ? $d8b1bffb46e6bac1$var$split(it, "") : $d8b1bffb46e6bac1$var$$Object(it);
} : $d8b1bffb46e6bac1$var$$Object;



$90d3b62c7d13c648$exports = function(it) {
    return $d8b1bffb46e6bac1$exports($fb9649058d88e05e$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$8d274edd5ac8b4e3$export$2d1720544b23b823 = $1b14517606367da3$exports ? $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $90d3b62c7d13c648$exports(O);
    P = $eddfdd2f934c39a2$exports(P);
    if ($c6249751f0bc488c$exports) try {
        return $8d274edd5ac8b4e3$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($7d2461ccc847d891$exports(O, P)) return $0606df0cd9938668$exports(!$52ac2d1f7b3fc221$exports($5b404d3e79dbd64d$export$2d1720544b23b823, O, P), O[P]);
};


var $7058f76fc2e3a64a$require$getOwnPropertyDescriptor = $8d274edd5ac8b4e3$export$2d1720544b23b823;

var $bf5de196043a4fd2$exports = {};




$bf5de196043a4fd2$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($9261b09349da61cf$exports(value)) $93b6f46cc432668a$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $43431a1908021c5f$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $9ed44e563230b16a$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $84231e3038cc1abd$exports = {};

var $05ddaa0c1772a48e$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $8fb63c1ae659eeb7$export$2d1720544b23b823;
var $34ed0f0fbefa4d2d$exports = {};



var $e663240c0e78013a$exports = {};

var $1dca9007867aa32d$exports = {};
var $2d9dedc240706176$exports = {};
var $c0b433f218e21d2d$exports = {};
var $c0b433f218e21d2d$var$ceil = Math.ceil;
var $c0b433f218e21d2d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$c0b433f218e21d2d$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $c0b433f218e21d2d$var$floor : $c0b433f218e21d2d$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$2d9dedc240706176$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $c0b433f218e21d2d$exports(number);
};


var $1dca9007867aa32d$var$max = Math.max;
var $1dca9007867aa32d$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1dca9007867aa32d$exports = function(index, length) {
    var integer = $2d9dedc240706176$exports(index);
    return integer < 0 ? $1dca9007867aa32d$var$max(integer + length, 0) : $1dca9007867aa32d$var$min(integer, length);
};


var $652464498d4572b8$exports = {};
var $7db5197aa28dc3ca$exports = {};

var $7db5197aa28dc3ca$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$7db5197aa28dc3ca$exports = function(argument) {
    return argument > 0 ? $7db5197aa28dc3ca$var$min($2d9dedc240706176$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$652464498d4572b8$exports = function(obj) {
    return $7db5197aa28dc3ca$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $e663240c0e78013a$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $90d3b62c7d13c648$exports($this);
        var length = $652464498d4572b8$exports(O);
        var index = $1dca9007867aa32d$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e663240c0e78013a$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e663240c0e78013a$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e663240c0e78013a$var$createMethod(false)
};


var $34ed0f0fbefa4d2d$require$indexOf = $e663240c0e78013a$exports.indexOf;

var $34ed0f0fbefa4d2d$var$push = $e5e00809db8eb123$exports([].push);
$34ed0f0fbefa4d2d$exports = function(object, names) {
    var O = $90d3b62c7d13c648$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$7d2461ccc847d891$exports($0796b0af43a3801a$exports, key) && $7d2461ccc847d891$exports(O, key) && $34ed0f0fbefa4d2d$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($7d2461ccc847d891$exports(O, key = names[i++])) ~$34ed0f0fbefa4d2d$require$indexOf(result, key) || $34ed0f0fbefa4d2d$var$push(result, key);
    return result;
};


var $24c31dabae1df012$exports = {};
// IE8- don't enum bug keys
$24c31dabae1df012$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $8fb63c1ae659eeb7$var$hiddenKeys = $24c31dabae1df012$exports.concat("length", "prototype");
$8fb63c1ae659eeb7$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $34ed0f0fbefa4d2d$exports(O, $8fb63c1ae659eeb7$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $644667aa7df66e73$export$2d1720544b23b823;
$644667aa7df66e73$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $05ddaa0c1772a48e$var$concat = $e5e00809db8eb123$exports([].concat);
// all object keys, includes non-enumerable and symbols
$05ddaa0c1772a48e$exports = $6bf58ff2790e62e4$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $8fb63c1ae659eeb7$export$2d1720544b23b823($3843f2a291eb95b4$exports(it));
    var getOwnPropertySymbols = $644667aa7df66e73$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $05ddaa0c1772a48e$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$84231e3038cc1abd$exports = function(target, source, exceptions) {
    var keys = $05ddaa0c1772a48e$exports(source);
    var defineProperty = $9ed44e563230b16a$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $8d274edd5ac8b4e3$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$7d2461ccc847d891$exports(target, key) && !(exceptions && $7d2461ccc847d891$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $4bf0205249f743fe$exports = {};


var $4bf0205249f743fe$var$replacement = /#|\.prototype\./;
var $4bf0205249f743fe$var$isForced = function(feature, detection) {
    var value = $4bf0205249f743fe$var$data[$4bf0205249f743fe$var$normalize(feature)];
    return value == $4bf0205249f743fe$var$POLYFILL ? true : value == $4bf0205249f743fe$var$NATIVE ? false : $9261b09349da61cf$exports(detection) ? $1eae0a73b36f2464$exports(detection) : !!detection;
};
var $4bf0205249f743fe$var$normalize = $4bf0205249f743fe$var$isForced.normalize = function(string) {
    return String(string).replace($4bf0205249f743fe$var$replacement, ".").toLowerCase();
};
var $4bf0205249f743fe$var$data = $4bf0205249f743fe$var$isForced.data = {};
var $4bf0205249f743fe$var$NATIVE = $4bf0205249f743fe$var$isForced.NATIVE = "N";
var $4bf0205249f743fe$var$POLYFILL = $4bf0205249f743fe$var$isForced.POLYFILL = "P";
$4bf0205249f743fe$exports = $4bf0205249f743fe$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $7058f76fc2e3a64a$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $1f3655405faf4b93$exports;
    else if (STATIC) target = $1f3655405faf4b93$exports[TARGET] || $43431a1908021c5f$exports(TARGET, {});
    else target = ($1f3655405faf4b93$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $7058f76fc2e3a64a$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $4bf0205249f743fe$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $84231e3038cc1abd$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $11de2b231b2859ac$exports(sourceProperty, "sham", true);
        $bf5de196043a4fd2$exports(target, key, sourceProperty, options);
    }
};



var $e2704fa259805163$exports = {};

var $86c2d867bf58e5bf$exports = {};

var $86c2d867bf58e5bf$var$FunctionPrototype = Function.prototype;
var $86c2d867bf58e5bf$var$apply = $86c2d867bf58e5bf$var$FunctionPrototype.apply;
var $86c2d867bf58e5bf$var$call = $86c2d867bf58e5bf$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$86c2d867bf58e5bf$exports = typeof Reflect == "object" && Reflect.apply || ($c3c0a5f76e5e916e$exports ? $86c2d867bf58e5bf$var$call.bind($86c2d867bf58e5bf$var$apply) : function() {
    return $86c2d867bf58e5bf$var$call.apply($86c2d867bf58e5bf$var$apply, arguments);
});


var $87792ed211fa2876$exports = {};
var $6c22f7c638581f91$exports = {};


$6c22f7c638581f91$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($ad4a9d272ee83106$exports(fn) === "Function") return $e5e00809db8eb123$exports(fn);
};




var $87792ed211fa2876$var$bind = $6c22f7c638581f91$exports($6c22f7c638581f91$exports.bind);
// optional / simple context binding
$87792ed211fa2876$exports = function(fn, that) {
    $828965f5bec31db8$exports(fn);
    return that === undefined ? fn : $c3c0a5f76e5e916e$exports ? $87792ed211fa2876$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $24506fe4729da444$exports = {};

$24506fe4729da444$exports = $6bf58ff2790e62e4$exports("document", "documentElement");


var $3f4447c6256f86d2$exports = {};

$3f4447c6256f86d2$exports = $e5e00809db8eb123$exports([].slice);



var $a7f591d020179c00$exports = {};
var $a7f591d020179c00$var$$TypeError = TypeError;
$a7f591d020179c00$exports = function(passed, required) {
    if (passed < required) throw $a7f591d020179c00$var$$TypeError("Not enough arguments");
    return passed;
};


var $777d68c3390001f4$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$777d68c3390001f4$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($e37ccc3a3c9edcb0$exports);


var $a7cfd674760c920c$exports = {};
var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};



$a7cfd674760c920c$exports = typeof $391299e0893a3dfa$exports != "undefined" && $ad4a9d272ee83106$exports($391299e0893a3dfa$exports) == "process";


var $e2704fa259805163$var$set = $1f3655405faf4b93$exports.setImmediate;
var $e2704fa259805163$var$clear = $1f3655405faf4b93$exports.clearImmediate;
var $e2704fa259805163$var$process = $1f3655405faf4b93$exports.process;
var $e2704fa259805163$var$Dispatch = $1f3655405faf4b93$exports.Dispatch;
var $e2704fa259805163$var$Function = $1f3655405faf4b93$exports.Function;
var $e2704fa259805163$var$MessageChannel = $1f3655405faf4b93$exports.MessageChannel;
var $e2704fa259805163$var$String = $1f3655405faf4b93$exports.String;
var $e2704fa259805163$var$counter = 0;
var $e2704fa259805163$var$queue = {};
var $e2704fa259805163$var$ONREADYSTATECHANGE = "onreadystatechange";
var $e2704fa259805163$var$$location, $e2704fa259805163$var$defer, $e2704fa259805163$var$channel, $e2704fa259805163$var$port;
$1eae0a73b36f2464$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $e2704fa259805163$var$$location = $1f3655405faf4b93$exports.location;
});
var $e2704fa259805163$var$run = function(id) {
    if ($7d2461ccc847d891$exports($e2704fa259805163$var$queue, id)) {
        var fn = $e2704fa259805163$var$queue[id];
        delete $e2704fa259805163$var$queue[id];
        fn();
    }
};
var $e2704fa259805163$var$runner = function(id) {
    return function() {
        $e2704fa259805163$var$run(id);
    };
};
var $e2704fa259805163$var$eventListener = function(event) {
    $e2704fa259805163$var$run(event.data);
};
var $e2704fa259805163$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $1f3655405faf4b93$exports.postMessage($e2704fa259805163$var$String(id), $e2704fa259805163$var$$location.protocol + "//" + $e2704fa259805163$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$e2704fa259805163$var$set || !$e2704fa259805163$var$clear) {
    $e2704fa259805163$var$set = function setImmediate(handler) {
        $a7f591d020179c00$exports(arguments.length, 1);
        var fn = $9261b09349da61cf$exports(handler) ? handler : $e2704fa259805163$var$Function(handler);
        var args = $3f4447c6256f86d2$exports(arguments, 1);
        $e2704fa259805163$var$queue[++$e2704fa259805163$var$counter] = function() {
            $86c2d867bf58e5bf$exports(fn, undefined, args);
        };
        $e2704fa259805163$var$defer($e2704fa259805163$var$counter);
        return $e2704fa259805163$var$counter;
    };
    $e2704fa259805163$var$clear = function clearImmediate(id) {
        delete $e2704fa259805163$var$queue[id];
    };
    // Node.js 0.8-
    if ($a7cfd674760c920c$exports) $e2704fa259805163$var$defer = function(id) {
        $e2704fa259805163$var$process.nextTick($e2704fa259805163$var$runner(id));
    };
    else if ($e2704fa259805163$var$Dispatch && $e2704fa259805163$var$Dispatch.now) $e2704fa259805163$var$defer = function(id) {
        $e2704fa259805163$var$Dispatch.now($e2704fa259805163$var$runner(id));
    };
    else if ($e2704fa259805163$var$MessageChannel && !$777d68c3390001f4$exports) {
        $e2704fa259805163$var$channel = new $e2704fa259805163$var$MessageChannel();
        $e2704fa259805163$var$port = $e2704fa259805163$var$channel.port2;
        $e2704fa259805163$var$channel.port1.onmessage = $e2704fa259805163$var$eventListener;
        $e2704fa259805163$var$defer = $87792ed211fa2876$exports($e2704fa259805163$var$port.postMessage, $e2704fa259805163$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($1f3655405faf4b93$exports.addEventListener && $9261b09349da61cf$exports($1f3655405faf4b93$exports.postMessage) && !$1f3655405faf4b93$exports.importScripts && $e2704fa259805163$var$$location && $e2704fa259805163$var$$location.protocol !== "file:" && !$1eae0a73b36f2464$exports($e2704fa259805163$var$globalPostMessageDefer)) {
        $e2704fa259805163$var$defer = $e2704fa259805163$var$globalPostMessageDefer;
        $1f3655405faf4b93$exports.addEventListener("message", $e2704fa259805163$var$eventListener, false);
    // IE8-
    } else if ($e2704fa259805163$var$ONREADYSTATECHANGE in $af583e15a6d46412$exports("script")) $e2704fa259805163$var$defer = function(id) {
        $24506fe4729da444$exports.appendChild($af583e15a6d46412$exports("script"))[$e2704fa259805163$var$ONREADYSTATECHANGE] = function() {
            $24506fe4729da444$exports.removeChild(this);
            $e2704fa259805163$var$run(id);
        };
    };
    else $e2704fa259805163$var$defer = function(id) {
        setTimeout($e2704fa259805163$var$runner(id), 0);
    };
}
$e2704fa259805163$exports = {
    set: $e2704fa259805163$var$set,
    clear: $e2704fa259805163$var$clear
};


var $784a5552ccbd4ccb$require$clearImmediate = $e2704fa259805163$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$7058f76fc2e3a64a$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1f3655405faf4b93$exports.clearImmediate !== $784a5552ccbd4ccb$require$clearImmediate
}, {
    clearImmediate: $784a5552ccbd4ccb$require$clearImmediate
});





var $98f0d5b64d1944ca$require$setTask = $e2704fa259805163$exports.set;
var $a83a092a39123e9a$exports = {};
"use strict";



var $156e6568e549918f$exports = {};
/* global Bun -- Deno case */ $156e6568e549918f$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $a83a092a39123e9a$var$Function = $1f3655405faf4b93$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $a83a092a39123e9a$var$WRAP = /MSIE .\./.test($e37ccc3a3c9edcb0$exports) || $156e6568e549918f$exports && function() {
    var version = $1f3655405faf4b93$exports.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$a83a092a39123e9a$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $a83a092a39123e9a$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $a7f591d020179c00$exports(arguments.length, 1) > firstParamIndex;
        var fn = $9261b09349da61cf$exports(handler) ? handler : $a83a092a39123e9a$var$Function(handler);
        var params = boundArgs ? $3f4447c6256f86d2$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $86c2d867bf58e5bf$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $98f0d5b64d1944ca$var$setImmediate = $1f3655405faf4b93$exports.setImmediate ? $a83a092a39123e9a$exports($98f0d5b64d1944ca$require$setTask, false) : $98f0d5b64d1944ca$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$7058f76fc2e3a64a$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1f3655405faf4b93$exports.setImmediate !== $98f0d5b64d1944ca$var$setImmediate
}, {
    setImmediate: $98f0d5b64d1944ca$var$setImmediate
});




const $ef19e442e0cefa4b$export$923ea8233b386e99 = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
const $ef19e442e0cefa4b$export$196440f71ed9f601 = 10;
const $ef19e442e0cefa4b$export$5feaddb1377b7f5e = 10;
const $ef19e442e0cefa4b$export$7167c830cefcb6b5 = "172c3821-6e2e-4036-af15-238151423204";
const $ef19e442e0cefa4b$export$3ce8858248d89a69 = 2.5;



/**
 * Will reject promise after a timeout.
 * @param {number} s seconds that we want this promise to reject after
 * @returns {Promise}
 * @author Anik Paul
 */ const $305e87f8b1fd70ca$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $305e87f8b1fd70ca$export$2b3ff41fecbef7c8 = async function(url, uploadData) {
    try {
        const fetchPro = uploadData ? fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(uploadData)
        }) : fetch(url);
        const res = await Promise.race([
            fetchPro,
            $305e87f8b1fd70ca$var$timeout((0, $ef19e442e0cefa4b$export$196440f71ed9f601))
        ]);
        const data = await res.json();
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        throw err;
    }
};


const $0f43de04ce3b058c$export$ca000e230c0caa3e = {
    recipe: {},
    search: {
        query: "",
        results: [],
        page: 1,
        resultsPerPage: (0, $ef19e442e0cefa4b$export$5feaddb1377b7f5e)
    },
    bookmarks: []
};
/**
 * Create a recipe object from api data, but with meaningful property
 * @param {Object} data The data that is recieved from api
 * @returns {Object} the recipe object
 * @author Anik Paul
 */ const $0f43de04ce3b058c$var$createRecipeObject = function(data) {
    const { recipe: recipe  } = data.data;
    return {
        id: recipe.id,
        title: recipe.title,
        publisher: recipe.publisher,
        sourceUrl: recipe.source_url,
        image: recipe.image_url,
        servings: recipe.servings,
        cookingTime: recipe.cooking_time,
        ingredients: recipe.ingredients,
        ...recipe.key && {
            key: recipe.key
        }
    };
};
const $0f43de04ce3b058c$export$b96725c7a035d60b = async function(id) {
    try {
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}${id}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        if ($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.some((bookmark)=>bookmark.id === id)) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
        else $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    } catch (err) {
        throw err;
    }
};
const $0f43de04ce3b058c$export$202b8e5cb363a0c4 = async function(query) {
    try {
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.query = query;
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?search=${query}&key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results = data.data.recipes.map((rec)=>{
            return {
                id: rec.id,
                title: rec.title,
                publisher: rec.publisher,
                image: rec.image_url,
                ...rec.key && {
                    key: rec.key
                }
            };
        });
        $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = 1;
    } catch (err) {
        throw err;
    }
};
const $0f43de04ce3b058c$export$8d7f79465139ab72 = function(page = $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.search.page = page;
    const start = (page - 1) * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage; //0;
    const end = page * $0f43de04ce3b058c$export$ca000e230c0caa3e.search.resultsPerPage; //9;
    return $0f43de04ce3b058c$export$ca000e230c0caa3e.search.results.slice(start, end);
};
const $0f43de04ce3b058c$export$5e23f4642ecad5ea = function(newServings) {
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.ingredients.forEach((ing)=>{
        ing.quantity = ing.quantity * newServings / $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings;
    // newQt = oldQt * newServings / oldServings
    });
    $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.servings = newServings;
};
/**
 * will store the bookmarks in local storage when a recipe is bookmarked or unbookmarked
 * @returns {undefined}
 * @author Anik Paul
 */ const $0f43de04ce3b058c$var$persistBookmarks = function() {
    localStorage.setItem("bookmarks", JSON.stringify($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks));
};
const $0f43de04ce3b058c$export$72009cc673d27d80 = function(recipe) {
    // Add bookmark
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.push(recipe);
    // Mark current recipe as bookmarked
    if (recipe.id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = true;
    $0f43de04ce3b058c$var$persistBookmarks();
};
const $0f43de04ce3b058c$export$136048bcb9946c75 = function(id) {
    // Delete bookmark
    const index = $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.findIndex((el)=>el.id === id);
    $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    // Mark current recipe as NOT bookmarked
    if (id === $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id) $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked = false;
    $0f43de04ce3b058c$var$persistBookmarks();
};
const $0f43de04ce3b058c$var$init = function() {
    const storage = localStorage.getItem("bookmarks");
    if (storage) $0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks = JSON.parse(storage);
};
$0f43de04ce3b058c$var$init();
/**
 * clear local storage (only for development stage)
 */ const $0f43de04ce3b058c$var$clearBookmarks = function() {
    localStorage.clear("bookmarks");
};
const $0f43de04ce3b058c$export$d660c2254e74960d = async function(newRecipe) {
    try {
        const ingredients = Object.entries(newRecipe).filter((entry)=>entry[0].startsWith("ingredient") && entry[1] !== "").map((ing)=>{
            const ingArr = ing[1].split(",").map((el)=>el.trim());
            if (ingArr.length !== 3) throw new Error("Wrong ingredient format! Please use the correct format :)");
            const [quantity, unit, description] = ingArr;
            return {
                quantity: quantity ? +quantity : null,
                unit: unit,
                description: description
            };
        });
        const recipe = {
            title: newRecipe.title,
            source_url: newRecipe.sourceUrl,
            image_url: newRecipe.image,
            publisher: newRecipe.publisher,
            cooking_time: +newRecipe.cookingTime,
            servings: +newRecipe.servings,
            ingredients: ingredients
        };
        const data = await (0, $305e87f8b1fd70ca$export$2b3ff41fecbef7c8)(`${(0, $ef19e442e0cefa4b$export$923ea8233b386e99)}?key=${(0, $ef19e442e0cefa4b$export$7167c830cefcb6b5)}`, recipe);
        $0f43de04ce3b058c$export$ca000e230c0caa3e.recipe = $0f43de04ce3b058c$var$createRecipeObject(data);
        $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        throw err;
    }
};



var $41666a46150491b3$exports = {};

$41666a46150491b3$exports = new URL((parcelRequire("kyEFX")).resolve("cPzGy"), import.meta.url).toString();


class $4c29d8503f9ec531$export$2e2bcd8739ae039 {
    _data;
    /**
   * Render the recieved object to the DOM
   * @param {Object | Object[]} data The data to be rendered (e.g recipe)
   * @param {boolean} [render=true] If false create murkup string instead of rendering to the DOM
   * @returns {undefined | string} a markup string is returned for invalid data
   * @this {Object} View instance
   * @author Anik Paul
   */ render(data, render = true) {
        if (!data || Array.isArray(data) && data.length === 0) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();
        if (!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    /**
   * Create a new markup. Then will compare this new html to to the current html. Then change 'text' and 'attribute' that actually has changed from the old version to the new version.
   * @param {Object | Object[]} data The data to be rendered (e.g recipe)
   * @returns {undefined | string} a markup string is returned for invalid data otherwise the new markup
   * @this {Object} View instance
   * @author Anik Paul
   */ update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // Updates changed TEXT
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            // Updates changed ATTRIBUTES
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    /**
   * Clear the element in DOM before loading a recipe
   */ _clear() {
        this._parentElement.innerHTML = "";
    }
    /**
   * Render a loading spinner to the DOM
   * @returns {undefined}
   * @this {Object} View instance
   * @author Anik Paul
   */ renderSpinner() {
        const markup = `
    <div class="spinner">
      <svg>
        <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports)))}#icon-loader"></use>
      </svg>
    </div>            
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    /**
   * Render an error message.
   * @param {string} message the error message to be rendered
   * @returns {undefined}
   * @this {Object} View instance
   * @author Anik Paul
   */ renderError(message = this._errorMessage) {
        const markup = `
    <div class="error">
      <div>
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports)))}#icon-alert-triangle"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>;
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    /**
   * Render an success message.
   * @param {string} message the success message to be rendered
   * @returns {undefined}
   * @this {Object} View instance
   * @author Anik Paul
   */ renderMessage(message = this._message) {
        const markup = `
    <div class="message">
      <div>
        <svg>
          <use href="${(0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports)))}#icon-smile"></use>
        </svg>
      </div>
      <p>${message}</p>
    </div>;
    `;
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
}



var $47fd1b3d76daecdb$exports = {};
// FRACTY CONVERTS DECIMAL NUMBERS TO FRACTIONS BY ASSUMING THAT TRAILING PATTERNS FROM 10^-2 CONTINUE TO REPEAT
// The assumption is based on the most standard numbering conventions
// e.g. 3.51 will convert to 3 51/100 while 3.511 will convert to 3 23/45
// Throw any number up to 16 digits long at fracty and let fracy do the work.
// If number is beyond 16 digits fracty will truncate at 15 digits to compensate for roundoff errors created in IEEE 754 Floating Point conversion.
$47fd1b3d76daecdb$exports = function(number) {
    let type;
    if (number < 0) {
        number = Math.abs(number);
        type = "-";
    } else type = "";
    if (number === undefined) return `Your input was undefined.`;
    if (isNaN(number)) return `"${number}" is not a number.`;
    if (number == 9999999999999999) return `${type}9999999999999999`;
    if (number > 9999999999999999) return `Too many digits in your integer to maintain IEEE 754 Floating Point conversion accuracy.`;
    if (Number.isInteger(number)) return `${type}${number}`;
    if (number < .000001) return "0";
    const numberString = number.toString();
    const entry = numberString.split(".");
    let integer = entry[0];
    let decimal;
    if (decimal == "0" && integer !== "0") return integer;
    else if (decimal == "0" && integer == "0") return "0";
    else if (numberString.length >= 17) decimal = entry[1].slice(0, entry[1].length - 1);
    else decimal = entry[1];
    if (decimal == "99" && integer !== "0") return `${integer} 99/100`;
    else if (decimal == "99" && integer == "0") return `99/100`;
    else if (1 - parseFloat(`.${decimal}`) < .0011) decimal = "999";
    if (decimal == undefined) return integer;
    const decimalRev = decimal.split("").reverse().join(""); //Reverse the string to look for patterns.
    const patternSearch = /^(\d+)\1{1,2}/; //This greedy regex matches the biggest pattern that starts at the beginning of the string (at the end, in the case of the reversed string). A lazy regex doesn't work because it only identifies subpatterns in cases where subpatterns exist (e.g. '88' in '388388388388'), thus pattern capture must be greedy.
    let pattern = decimalRev.match(patternSearch); //If there's a pattern, it's full sequence is in [0] of this array and the single unit is in [1] but it may still need to be reduced further.
    if (pattern && decimal.length > 2) {
        let patternSequence = pattern[0].split("").reverse().join("");
        let endPattern = pattern[1].split("").reverse().join("");
        if (endPattern.length > 1) {
            let endPatternArray = endPattern.split("");
            let testSingleUnit = 1;
            for(let i = 0; i < endPatternArray.length; i++)testSingleUnit /= endPatternArray[0] / endPatternArray[i];
            if (testSingleUnit === 1) endPattern = endPatternArray[0];
        }
        if (endPattern.length > 1 && endPattern.length % 2 === 0) endPattern = parseInt(endPattern.slice(0, endPattern.length / 2), 10) - parseInt(endPattern.slice(endPattern.length / 2, endPattern.length), 10) === 0 ? endPattern.slice(0, endPattern.length / 2) : endPattern;
        return $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type); //Begin calculating the numerator and denominator for decimals that have a pattern.
    } else return $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type); //Begin calculating the numerator and denominator for decimals that don't have a pattern.
};
//IF THERE'S A TRAILING PATTERN FRACTY DIVIDES THE INPUT BY ONE SUBTRACTED FROM THE NEAREST BASE 10 NUMBER WITH NUMBER OF ZEROS EQUAL TO THE LENGTH OF THE REPEATED PATTERN (I.E. A SERIES OF 9'S) MULTIPLIED BY THE BASE 10 NUMBER GREATER THAN AND CLOSEST TO THE INPUT.
function $47fd1b3d76daecdb$var$yesRepeat(decimal, endPattern, patternSequence, integer, type) {
    const rep = true; //The numerator repeats.
    const nonPatternLength = decimal.length - patternSequence.length >= 1 ? decimal.length - patternSequence.length : 1; //Does the length of the non pattern segment of the input = 0? If it does, that's incorrect since we know it must equal at least 1, otherwise it's the length of the decimal input minus the length of the full pattern.
    const decimalMultiplier2 = Math.pow(10, nonPatternLength); //Second multiplier to use.
    const float = parseFloat(`0.${decimal}`); //Convert the decimal input to a floating point number.
    const decimalMultiplier1 = Math.pow(10, endPattern.length); //Find the right multiplier to use for both numerator and denominator, which will later have 1 subtracted from it in the case of the denominator.
    const numerator = Math.round((float * decimalMultiplier1 - float) * Math.pow(10, nonPatternLength)); //Find the numerator to be used in calculating the fraction that contains a repeating trailing sequence.
    const denominator = (decimalMultiplier1 - 1) * decimalMultiplier2; //Caluculate the denominator using the equation for repeating trailing sequences.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Further reduce the numerator and denominator.
}
//IF THERE'S NO TRAILING PATTERN FRACTY DIVIDES THE INPUT BY THE NEAREST BASE 10 INTEGER GREATER THAN THE NUMERATOR.
function $47fd1b3d76daecdb$var$noRepeat(decimal, integer, type) {
    const rep = false; //The numerator doesn't repeat.
    const numerator = parseInt(decimal, 10); //Numerator begins as decimal input converted into an integer.
    const denominator = Math.pow(10, decimal.length); //Denominator begins as 10 to the power of the length of the numerator.
    return $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep); //Reduce the numerator and denominator.
}
//FRACTY REDUCES THE FRACTION.
function $47fd1b3d76daecdb$var$reduce(numerator, denominator, integer, type, rep) {
    const primeNumberArray = [
        2,
        3,
        5
    ]; //If the numerator isn't from a repeating decimal case, the initialized array of prime numbers will suffice to find the common denominators.
    if (rep === true) {
        for(let i = 3; i * i <= numerator; i += 2)if (numerator % i === 0) primeNumberArray.push(i);
    }
    let j = 0; //Initialize counter over the prime number array for the while loop.
    let comDenom = 1; //Initialize the common denominator.
    let num = numerator; //Initialize the numerator.
    let den = denominator; //Initialize the denominator.
    while(j <= primeNumberArray.length)if (num % primeNumberArray[j] === 0 && den % primeNumberArray[j] === 0) {
        comDenom = comDenom * primeNumberArray[j];
        num = num / primeNumberArray[j];
        den = den / primeNumberArray[j];
    } else j++;
    return $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type);
}
//FRACTY RETURNS THE REDUCED FRACTION AS A STRING.
function $47fd1b3d76daecdb$var$returnStrings(den, num, integer, type) {
    if (den === 1 && num === 1) {
        integer = `${type}${(parseInt(integer) + 1).toString()}`; //Add 1 to the integer and return a string without a fraction.
        return `${integer}`;
    } else if (num === 0) return `${type}${integer}`;
    else if (integer == "0") return `${type}${num}/${den}`;
    else return `${type}${integer} ${num}/${den}`; //If there's an integer and a fraction return both.
}


class $96ae62c5a8e43877$export$41b9f6ec320e4352 extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".recipe");
    _errorMessage = `Oops! No recipes found for your query. Please try again!`;
    _message = "";
    /**
   * Generate a markup string of a full recipe
   * @returns {string}
   * @this {Object} RecipeView instance
   * @author Anik Paul
   */ _generateMarkup() {
        return `
    <figure class="recipe__fig">
      <img src="${this._data.image}" alt="${this._data.title}" class="recipe__img" />
      <h1 class="recipe__title">
        <span>${this._data.title}</span>
      </h1>
    </figure>

    <div class="recipe__details">
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-clock"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--minutes">${this._data.cookingTime}</span>
        <span class="recipe__info-text">minutes</span>
      </div>
      <div class="recipe__info">
        <svg class="recipe__info-icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-users"></use>
        </svg>
        <span class="recipe__info-data recipe__info-data--people">${this._data.servings}</span>
        <span class="recipe__info-text">servings</span>

        <div class="recipe__info-buttons">
          <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings - 1}">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-minus-circle"></use>
            </svg>
          </button>
          <button class="btn--tiny btn--update-servings" data-update-to="${this._data.servings + 1}">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-plus-circle"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="recipe__user-generated ${this._data.key ? "" : "hidden"}">
        <svg>
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-user"></use>
        </svg>
      </div>
      <button class="btn--round btn--bookmark">
        <svg class="">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-bookmark${this._data.bookmarked ? "-fill" : ""}"></use>
        </svg>
      </button>
    </div>

    <div class="recipe__ingredients">
      <h2 class="heading--2">Recipe ingredients</h2>
      <ul class="recipe__ingredient-list">
      ${this._data.ingredients.map(this._generateMarkupIngredient).join("")}   
      </ul>
    </div>

    <div class="recipe__directions">
      <h2 class="heading--2">How to cook it</h2>
      <p class="recipe__directions-text">
        This recipe was carefully designed and tested by
        <span class="recipe__publisher">${this._data.publisher}</span>. Please check out
        directions at their website.
      </p>
      <a
        class="btn--small recipe__btn"
        href="${this._data.sourceUrl}"
        target="_blank"
      >
        <span>Directions</span>
        <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-arrow-right"></use>
        </svg>
      </a>
    </div>
  `;
    }
    /**
   * generate a markup string with lists of total ingredients
   * @param {Object} ing each ingredient of a recipe
   * @returns {string} a markup string is returned
   * @author Anik Paul
   */ _generateMarkupIngredient(ing) {
        return `
        <li class="recipe__ingredient">
          <svg class="recipe__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-check"></use>
          </svg>
          <div class="recipe__quantity">${ing.quantity ? (0, (/*@__PURE__*/$parcel$interopDefault($47fd1b3d76daecdb$exports)))(ing.quantity).toString() : ""}</div>
          <div class="recipe__description">
            <span class="recipe__unit">${ing.unit}</span>
            ${ing.description}
          </div>
        </li>
    `;
    }
    /**
   * will listen for hashchange and load event
   * @param {Function} handler the control function (controlRecipes), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerRender(handler) {
        [
            "hashchange",
            "load"
        ].forEach((ev)=>window.addEventListener(ev, handler));
    }
    /**
   * will listen for click event on the update servings button
   * @param {Function} handler the control function (controlServings), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerUpdateServings(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--update-servings");
            if (!btn) return;
            const { updateTo: updateTo  } = btn.dataset;
            if (+updateTo > 0) handler(+updateTo);
        });
    }
    /**
   * will listen for click event on the update servings button
   * @param {Function} handler the control function (controlAddBookmark), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerAddBookmark(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--bookmark");
            if (!btn) return;
            handler();
        });
    }
}
var $96ae62c5a8e43877$export$2e2bcd8739ae039 = new $96ae62c5a8e43877$export$41b9f6ec320e4352();


class $59c24ae67929f662$var$SearchView {
    _parentElement = document.querySelector(".search");
    /**
   * will return the query string for a recipe from the search field
   * @returns {string} query the query string from the search field
   */ getQuery() {
        const query = this._parentElement.querySelector(".search__field").value;
        this._clearInput();
        return query;
    }
    /**
   * Clear the input value in search field after a search
   */ _clearInput() {
        this._parentElement.querySelector(".search__field").value = "";
    }
    /**
   * will listen for submit event
   * @param {Function} handler the control function (controlSearchResults), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerSearch(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            handler();
        });
    }
}
var $59c24ae67929f662$export$2e2bcd8739ae039 = new $59c24ae67929f662$var$SearchView();





class $8b7f4ee14226945a$var$PreviewView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = "";
    /**
   * generate a markup string for the preview elements
   * @returns {string} a markup string is returned
   * @author Anik Paul
   */ _generateMarkup() {
        const id = window.location.hash.slice(1);
        return `
    <li class="preview">
      <a class="preview__link ${this._data.id === id ? "preview__link--active" : ""}" href="#${this._data.id}">
        <figure class="preview__fig">
          <img src="${this._data.image}" alt="${this._data.title}" />
        </figure>
        <div class="preview__data">
          <h4 class="preview__title">${this._data.title}</h4>
          <p class="preview__publisher">${this._data.publisher}</p>
          <div class="preview__user-generated ${this._data.key ? "" : "hidden"}">
            <svg>
              <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-user"></use>
            </svg>
          </div>
        </div>
      </a>
  </li>;
    `;
    }
}
var $8b7f4ee14226945a$export$2e2bcd8739ae039 = new $8b7f4ee14226945a$var$PreviewView();



class $9b828d38d31fb13a$var$ResultsView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".results");
    _errorMessage = `Oops! No recipes found for your query. Please try again!`;
    _message = "";
    /**
   * Generate a markup string of a searched recipe
   * @returns {string}
   * @author Anik Paul
   */ _generateMarkup() {
        return this._data.map((result)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(result, false)).join("");
    }
}
var $9b828d38d31fb13a$export$2e2bcd8739ae039 = new $9b828d38d31fb13a$var$ResultsView();




class $d5cb92833965f6d1$var$PaginationView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".pagination");
    /**
   * will listen for click event
   * @param {Function} handler the control function (controlPagination), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerClick(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn--inline");
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    /**
   * Generate a markup string of the pagination buttons according the different conditions.
   * @returns {string}
   * @this {Object} PaginationView instance
   * @author Anik Paul
   */ _generateMarkup() {
        const curPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / this._data.resultsPerPage);
        // Page 1, and there are other pages
        if (curPage === 1 && numPages > 1) return `
        <button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-arrow-right"></use>
          </svg>
          <span>Page ${curPage + 1}</span>
        </button>
      `;
        // Last pages
        if (curPage === numPages && numPages > 1) return `
        <button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-arrow-left"></use>
          </svg>
          <span>Page ${curPage - 1}</span>
        </button>
      `;
        // Other pages
        if (curPage < numPages) return `
        <button data-goto="${curPage - 1}" class="btn--inline pagination__btn--prev">
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-arrow-left"></use>
          </svg>
          <span>Page ${curPage - 1}</span>
        </button>
        <button data-goto="${curPage + 1}" class="btn--inline pagination__btn--next">
          <svg class="search__icon">
            <use href="${0, (/*@__PURE__*/$parcel$interopDefault($41666a46150491b3$exports))}#icon-arrow-right"></use>
          </svg>
          <span>Page ${curPage + 1}</span>
        </button>
      `;
        // Page 1, and there are NO other pages
        return "";
    }
}
var $d5cb92833965f6d1$export$2e2bcd8739ae039 = new $d5cb92833965f6d1$var$PaginationView();





class $bb8c26dfe22e3ec0$var$BookmarksView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".bookmarks__list");
    _errorMessage = `No bookmarks yet. Find a nice recipe and bookmark it ;)`;
    _message = "";
    /**
   * will listen for load event
   * @param {Function} handler the control function (controlBookmarks), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    /**
   * Generate a markup string of a searched recipe
   * @returns {string}
   * @author Anik Paul
   */ _generateMarkup() {
        return this._data.map((bookmark)=>(0, $8b7f4ee14226945a$export$2e2bcd8739ae039).render(bookmark, false)).join("");
    }
}
var $bb8c26dfe22e3ec0$export$2e2bcd8739ae039 = new $bb8c26dfe22e3ec0$var$BookmarksView();




class $69f230dbd0cf4929$var$AddRecipeView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".upload");
    _message = "Recipe uploaded successfully!  \uD83C\uDF89";
    _window = document.querySelector(".add-recipe-window");
    _overlay = document.querySelector(".overlay");
    _btnOpen = document.querySelector(".nav__btn--add-recipe");
    _btnClose = document.querySelector(".btn--close-modal");
    constructor(){
        super();
        this._addHandlerShowWindow();
        this._addHandlerHideWindow();
    }
    /**
   * will add and remove hidden class from overlay and window
   */ toggleWindow() {
        this._overlay.classList.toggle("hidden");
        this._window.classList.toggle("hidden");
    }
    /**
   * will listen for the click event and show the form
   */ _addHandlerShowWindow() {
        this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    }
    /**
   * will listen for the click event and hide the form
   */ _addHandlerHideWindow() {
        this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
        this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    }
    /**
   * will listen for submit button
   * @param {Function} handler the control function (controlAddRecipe), which will be executed as soon as the event happens.
   * @returns {undefined}
   * @author Anik Paul
   */ addHandlerUpload(handler) {
        this._parentElement.addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {}
}
var $69f230dbd0cf4929$export$2e2bcd8739ae039 = new $69f230dbd0cf4929$var$AddRecipeView();



class $775578ca2ec29759$var$FooterView extends (0, $4c29d8503f9ec531$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".year");
    constructor(){
        super();
        // update current year
        this._updateCurrentYear();
    }
    _updateCurrentYear() {
        const currentYear = new Date().getFullYear();
        this._parentElement.textContent = currentYear;
    }
}
var $775578ca2ec29759$export$2e2bcd8739ae039 = new $775578ca2ec29759$var$FooterView();


var $fa69a9a3405c626c$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa69a9a3405c626c$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $fa69a9a3405c626c$exports));
try {
    regeneratorRuntime = $fa69a9a3405c626c$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $fa69a9a3405c626c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($fa69a9a3405c626c$var$runtime);
}


if (null) null.accept();
/**
 * Will control loading and rendering recipe data.
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlRecipes = async function() {
    try {
        const id = window.location.hash.slice(1);
        if (!id) return;
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderSpinner();
        // 0) Update results view to mark selected search result
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$8d7f79465139ab72());
        // 1) Updating bookmarks view
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        // 2) Loading recipe
        await $0f43de04ce3b058c$export$b96725c7a035d60b(id);
        // 3) Rendering recipe
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    } catch (err) {
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).renderError();
    }
};
/**
 * Will control loading and rendering searched recipe data.
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlSearchResults = async function() {
    try {
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).renderSpinner();
        // 1) Get search query
        const query = (0, $59c24ae67929f662$export$2e2bcd8739ae039).getQuery();
        if (!query) return;
        // 2) Load search results
        await $0f43de04ce3b058c$export$202b8e5cb363a0c4(query);
        // 3) Render results
        (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72());
        // 4) Render initial pagination buttons
        (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
    } catch (err) {
        console.log(err);
    }
};
/**
 * Will control rendering new recipe data according the the page number. Will update the pagination buttons according to that new results.
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlPagination = function(goToPage) {
    // 1) Render NEW results
    (0, $9b828d38d31fb13a$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$8d7f79465139ab72(goToPage));
    // 2) Render NEW pagination buttons
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.search);
};
/**
 * Will handle updating the service and recipe according to new servings
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlServings = function(newServings) {
    // Update the recipe servings (in state)
    $0f43de04ce3b058c$export$5e23f4642ecad5ea(newServings);
    // Update the recipe view
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
};
/**
 * Will handle adding and removing a recipe as bookmarked
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlAddBookmark = function() {
    // 1) Add/remove bookmar
    if (!$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.bookmarked) $0f43de04ce3b058c$export$72009cc673d27d80($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    else $0f43de04ce3b058c$export$136048bcb9946c75($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id);
    // 2) Update recipe view
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).update($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
    // 3) Render bookmars
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
/**
 * Will render the bookmarks in the bookmark panel
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlBookmarks = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
};
/**
 * Will handle adding a new recipe and bookmark it
 * @returns {undefined}
 * @author Anik Paul
 */ const $292b382f80842f30$var$controlAddRecipe = async function(newRecipe) {
    try {
        // Show loading spinner
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderSpinner();
        // Updload the recipe data
        await $0f43de04ce3b058c$export$d660c2254e74960d(newRecipe);
        // Render recipe
        (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.recipe);
        // Success message
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderMessage();
        // Render bookmark view
        (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).render($0f43de04ce3b058c$export$ca000e230c0caa3e.bookmarks);
        // Change ID in url
        window.history.pushState(null, "", `#${$0f43de04ce3b058c$export$ca000e230c0caa3e.recipe.id}`);
        // Close form window
        setTimeout(function() {
            (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).toggleWindow();
        }, (0, $ef19e442e0cefa4b$export$3ce8858248d89a69) * 1000);
    } catch (err) {
        console.error(err);
        (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).renderError(err.message);
    }
};
/**
 * Will execute as soon as application starts anc call 'addHandler() with the control function.
 * @author Anik Paul
 */ const $292b382f80842f30$var$init = function() {
    (0, $bb8c26dfe22e3ec0$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlBookmarks);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerRender($292b382f80842f30$var$controlRecipes);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerUpdateServings($292b382f80842f30$var$controlServings);
    (0, $96ae62c5a8e43877$export$2e2bcd8739ae039).addHandlerAddBookmark($292b382f80842f30$var$controlAddBookmark);
    (0, $59c24ae67929f662$export$2e2bcd8739ae039).addHandlerSearch($292b382f80842f30$var$controlSearchResults);
    (0, $d5cb92833965f6d1$export$2e2bcd8739ae039).addHandlerClick($292b382f80842f30$var$controlPagination);
    (0, $69f230dbd0cf4929$export$2e2bcd8739ae039).addHandlerUpload($292b382f80842f30$var$controlAddRecipe);
};
$292b382f80842f30$var$init();


//# sourceMappingURL=index.5c46e4b0.js.map
